<template>
  <v-row no-gutters>
    <v-col cols="12" sm="6" md="6">
      <v-data-table
        dense
        :headers="headers"
        :items="allActivities"
        sort-by="act_type_id"
        class="elevation-1"
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title></v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-on="on"
                  :disabled="disable"
                  >New</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-for="header in headers"
                        :key="header.value"
                      >
                        <v-text-field
                          v-if="
                            header.value != 'action' &&
                              header.type != 'toggle' &&
                              header.type != 'select' &&
                              header.type != 'act_datetime' &&
                              header.type != 'end_act_datetime' &&
                              header.type != 'hidden'
                          "
                          v-model="editedItem[header.value]"
                          :label="header.text"
                          :disabled="header.disabled"
                        ></v-text-field>
                        <v-autocomplete
                          v-if="header.type === 'select'"
                          :items="activity_types"
                          v-model="editedItem[header.id]"
                          item-text="type_name"
                          item-value="type_id"
                          :label="header.text"
                          auto-select-first
                          no-data-text="Type Not Added"
                          :rules="[
                            () =>
                              !!editedItem[header.value] ||
                              'This field is required'
                          ]"
                          :error-messages="errorMessage"
                          required
                        ></v-autocomplete>
                        <v-switch
                          v-if="header.type === 'toggle'"
                          v-model="priority_toggle"
                          :label="header.text"
                          :value="priority_toggle"
                        ></v-switch>
                        <v-menu
                          v-model="menu1"
                          v-if="header.type === 'act_datetime'"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="act_datetime"
                              v-if="header.type === 'act_datetime'"
                              :label="header.text"
                              prepend-icon="mdi mdi-calendar"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="act_datetime"
                            @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu2"
                          v-if="
                            header.type === 'end_act_datetime' &&
                              editedIndex > -1
                          "
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="end_act_datetime"
                              v-if="header.type === 'end_act_datetime'"
                              :label="header.text"
                              prepend-icon="mdi mdi-calendar"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="end_act_datetime"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mdi mdi-border-color"
            @click="editItem(item)"
          ></v-icon>
        </template>
        <template v-slot:no-data>
          No Data. Please Select A Log
        </template>
      </v-data-table>
    </v-col>
    <!--
      <v-col cols="6" md="5">
            hi hi
      </v-col> 
      -->
  </v-row>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { EventBus } from "../main";

export default {
  name: "ShipActivitiesDataTable",
  props: ["radio_logID", "vessel_name"],
  data: () => ({
    dialog: false,
    disable: true,
    loading: false,
    menu1: false,
    menu2: false,
    act_datetime: new Date().toISOString().substr(0, 10),
    end_act_datetime: new Date().toISOString().substr(0, 10),
    show: false,
    priority_toggle: false,
    search: "",
    errorMessage: "",
    formHasError: false,
    headers: [
      {
        text: "Activity Type",
        align: "left",
        sortable: false,
        value: "act_type_name",
        id: "act_type_id",
        type: "select"
      },
      { text: "Date & Time", value: "act_date_time", type: "act_datetime" },
      {
        text: "End Date & Time",
        value: "end_act_datetime",
        type: "end_act_datetime"
      },
      { text: "Duration (Days)", value: "", disabled: true },
      { text: "Priority Shifting", value: "is_priority", type: "toggle" },
      { text: "Rate", value: "rate", disabled: true },
      { text: "Actions", value: "action", sortable: false }
    ],
    activity_types: [],
    activities: [],
    editedIndex: -1,
    editedItem: {
      act_type_id: "",
      act_date_time: "",
      end_act_datetime: "",
      is_priority: "",
      rate: ""
    },
    defaultItem: {
      act_type_id: "",
      act_date_time: "",
      end_act_datetime: "",
      is_priority: "",
      rate: 0
    }
  }),

  created() {
    EventBus.$on("changeLoadingState", evnt => {
      this.loadingStateChange(evnt);
    });
  },

  computed: {
    ...mapGetters("activities", ["allActivities"]),
    formTitle() {
      return this.editedIndex === -1
        ? "New Acitivity for " + this.vessel_name
        : "Edit Activity";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();

      if (val)
        this.$store.dispatch("act_types/fetchTypes").then(res => {
          this.activity_types = res;
        });
    },

    radio_logID(val) {
      this.disable = val ? false : true;
    }
  },

  methods: {
    initialize(_id) {
      this.loading = true;
      this.$store.dispatch("activities/fetchActivities", _id).then(res => {
        this.loading = false;
      });
    },
    checkID() {
      if (!this.radio_logID) {
        this.$noty.success("please select a radio log first!");
        return;
      }
    },
    loadingStateChange(state) {
      this.loading = state;
    },

    editItem(item) {
      this.editedIndex = this.allActivities.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.priority_toggle = this.editedItem.is_priority; // to update this code to handle null values as false
      this.act_datetime = this.editedItem.act_date_time
        ? moment(this.editedItem.act_date_time).format("YYYY-MM-DD")
        : new Date().toISOString().substr(0, 10);
      this.end_act_datetime = this.editedItem.end_act_datetime
        ? moment(this.editedItem.end_act_datetime).format("YYYY-MM-DD")
        : new Date().toISOString().substr(0, 10);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        let data = {
          ship_ac_id: this.editedItem.activity_id,
          act_type_id: this.editedItem.act_type_id,
          act_date_time: moment(this.editedItem.act_date_time).format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          end_act_datetime: this.act_date_time,
          end_act_datetime: this.end_act_datetime,
          is_priority: this.checkNull(this.priority_toggle),
          radio_log_id: this.radio_logID
        };

        this.$store.dispatch("activities/updateActivity", data).then(res => {
          if (res.success) {
            this.initialize(this.radio_logID);
            this.$noty.success(res.success);
          } else this.$noty.warning(res.error);
          return;
        });
      } else {
        let data = {
          act_type_id: this.editedItem.act_type_id,
          is_priority: this.priority_toggle,
          act_date_time: this.act_datetime,
          end_act_datetime: null,
          radio_log_id: this.radio_logID
        };
        this.$store.dispatch("activities/saveActivity", data).then(res => {
          if (res.success) {
            this.initialize(this.radio_logID);
            this.$noty.success(res.success);
          } else this.$noty.warning(res.error);
          return;
        });
      }
      this.close();
    },
    checkNull(n) {
      if (typeof n === "undefined" || n === null) return 0;
      else return true;
    }
  }
};
</script>
